"use strict";
/**
 * @module Services.SessionFetchQuery
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Server result from a SESSION_FETCH_QUERY request.
 */
var SessionFetchQueryResult = /** @class */ (function () {
    /**
     * Create a new SessionFetchQueryResult instance
     *
     * @param results       the sessions that have been fetched
     * @param totalCount    the total number of matched sessions for the filter
     */
    function SessionFetchQueryResult(results, totalCount, errors) {
        this.results = results;
        this.totalCount = totalCount;
        this.errors = errors;
    }
    return SessionFetchQueryResult;
}());
exports.SessionFetchQueryResult = SessionFetchQueryResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/session-fetch-query/session-fetch-query-result.js
// module id = 1307
// module chunks = 1